import styled from 'styled-components';

import { backgroundImages } from 'polished';
import { gradient } from 'styles/colors';
import { fromLarge } from 'styleUtils/mediaQueries';

export const Header = styled.header`
    color: white;
    padding: 20px 0;

    ${fromLarge`
      padding: 50px 0;
    `}

    ${backgroundImages(gradient, `url("/images/banner.jpg")`)}

    .webp & {
        ${backgroundImages(gradient, `url("/images/banner.webp")`)}
    }
    background-position: 100% 70%;
    background-size: cover;
`;
